import { render, staticRenderFns } from "./WLoaderFull.vue?vue&type=template&id=2f2b5111&"
import script from "./WLoaderFull.vue?vue&type=script&lang=ts&"
export * from "./WLoaderFull.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports